var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import Title from '../../atoms/Title';
import CtaBtn from '../../atoms/CtaBtn';
import { neutralDay } from '@teamsparta/design-system';
import CtaTextContainer from '../../molecules/CtaTextContainer';
import CtaText from '../../atoms/CtaText';
import { VerticalGap } from '../../atoms/Gap/Gap';
import { LogoKakao } from '../../atoms/Svgs';
import { onClickKakaoLogin } from '../../../businessLogics';
import { BottomContents, MainContents } from '../../../styles/_common.style';
import { useIsMobile } from '../../../businessLogics/hooks';
import { useAtomValue } from 'jotai';
import { userAtom } from '../../../stores';
var LoginKakao = function (_a) {
    var setIsShow = _a.setIsShow, nextPage = _a.nextPage, CPLogger = _a.CPLogger;
    var isMobile = useIsMobile();
    var user = useAtomValue(userAtom);
    return (_jsxs(_Fragment, { children: [_jsxs(MainContents, __assign({ paddingTop: 170, isCenterInMobile: true }, { children: [_jsxs(Title, { children: [(user === null || user === void 0 ? void 0 : user.created_at) && (_jsxs(_Fragment, { children: [user === null || user === void 0 ? void 0 : user.created_at, _jsx("br", {})] })), "\uCE74\uCE74\uC624\uB85C \uAC00\uC785\uD55C \uACC4\uC815\uC774 \uC788\uC5B4\uC694!"] }), !isMobile && (_jsxs(_Fragment, { children: [_jsx(VerticalGap, { size: 40 }), _jsxs(CtaBtn, __assign({ bgColor: '#FEE500', color: neutralDay.gray100, onClickAction: function () {
                                    onClickKakaoLogin(setIsShow, CPLogger, nextPage);
                                } }, { children: [_jsx(LogoKakao, {}), " \uCE74\uCE74\uC624\uB85C 3\uCD08\uB9CC\uC5D0 \uC2DC\uC791\uD558\uAE30"] }))] }))] })), _jsxs(BottomContents, { children: [isMobile && (_jsxs(_Fragment, { children: [_jsxs(CtaBtn, __assign({ bgColor: '#FEE500', color: neutralDay.gray100, onClickAction: function () {
                                    onClickKakaoLogin(setIsShow, CPLogger, nextPage);
                                } }, { children: [_jsx(LogoKakao, {}), " \uCE74\uCE74\uC624\uB85C 3\uCD08\uB9CC\uC5D0 \uC2DC\uC791\uD558\uAE30"] })), _jsx(VerticalGap, { size: 24 })] })), _jsxs(CtaTextContainer, { children: ["\uD68C\uC6D0\uB2D8\uC758 \uACC4\uC815\uC774 \uC544\uB2CC\uAC00\uC694?", _jsx(CtaText, { text: '문의하기', color: neutralDay.gray90, onClickAction: function () {
                                    window.open('https://spartacodingclub.channel.io/support-bots/54086', '_blank');
                                } })] })] })] }));
};
export default LoginKakao;
//# sourceMappingURL=LoginKakao.js.map